export default __webpack_public_path__ + "static/media/completed_desktop.75f9bba6.svg";